export default __webpack_public_path__ + "static/banner-real-stories-saving-spending-lending-kate-b78779420ec6c6bc3e3ecf03ea6760c1.jpg";